// extracted by mini-css-extract-plugin
module.exports = {"StatsCarousel":"StatsCarousel_StatsCarousel__1o157","Slides":"StatsCarousel_Slides__y2erw","Actions":"StatsCarousel_Actions__3Aq3Z","SrOnly":"StatsCarousel_SrOnly__3HfEo"};